<template>
  <b-overlay
    :show="loader.pagina"
    opacity="0.50"
    rounded="sm"
  >
    <b-row>
      <!-- list dinamic -->
      <b-col
        v-for="item in kbtutoriales"
        :id="'option-'+ item.id"
        :key="item.id"
        md="4"
        sm="12"
      >

        <b-card>
          <h4>{{ item.title }}</h4>
          <b-card-text class="mt-1">
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="item.video"
              allowfullscreen
            />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { getData } from '@core/utils/http/general'
import {
  BRow, BCol,
  BEmbed,
  BOverlay,
  BCard,
  BCardText,
} from 'bootstrap-vue'
import store from '@/store'
import { ref, onMounted } from '@vue/composition-api'
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BEmbed,
    BOverlay,
    BCard,
    BCardText,
  },
  data() {
    return {
      videourl: '',
      loader: {
        pagina: false,
      },
      kbtutoriales: [],
    }
  },
  created() {
    this.get_video()
  },
  methods: {
    get_video() {
      this.loader.pagina = true
      getData({ action: 7, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) this.kbtutoriales = response.data.data
          else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Sección en construcción`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.pagina = false
        }).catch(err => {
          this.loader.pagina = false
          this.$bvToast.toast(err, {
            title: 'Error, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
  setup() {
    const flagcontinue = ref(false)
    const verificando = () => {
      if (store.state.cuenta.session.tknmdl != null) {
        flagcontinue.value = true
      }
    }
    onMounted(
      () => {
        verificando()
      },
    )

    return {
      verificando,
      flagcontinue,
    }
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
</style>
